import isZeroDecimalCurrency from 'helpers/isZeroDecimalCurrency'
import { StripePrice } from 'hooks/useApi'
import { PaymentPlan } from 'types/payment'

export default function mapStripePriceToPlan(price: StripePrice): PaymentPlan {
  return {
    code: price.id,
    name: price.product,
    intervalLength: price.recurring.interval === 'year' ? 12 : 1,
    currencies: [
      {
        currency: price.currency,
        unitAmount: sanitizeZeroDecimalCurrency({
          currency: price.currency,
          unitAmount: price.unit_amount,
        }),
        unitAmountRamp: price.second_year_unit_amount
          ? sanitizeZeroDecimalCurrency({
              currency: price.currency,
              unitAmount: price.second_year_unit_amount,
            })
          : 0,
      },
    ],
  }
}

function sanitizeZeroDecimalCurrency({
  currency,
  unitAmount,
}: {
  currency: string
  unitAmount: number
}): number {
  return isZeroDecimalCurrency(currency) ? unitAmount : unitAmount / 100
}
